import { Market, PrivacySettingToggles } from '../types/market';
import { pl as adConfig } from '../ads';

const market: Market = {
  countryCode: 'pl',
  active: false,
  permanentRedirect: true,
  sitename: 'Kompario',
  redirectHosts: ['m.kompario.pl', 'www.kompario.pl'],
  trackerProxy: 'rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com',
  superSearchEndpoint: 'https://search.kompario.pl/rfe',
  sites: {
    production: 'https://kompario.pl',
    forum: undefined,
  },
  hrefLang: ['pl'],
  locale: 'pl',
  api: {
    default: 'http://int-api-pl.prisjakt.io:8080/v1',
  },
  classicProxy: {
    host: 'int-classic-pl.prisjakt.io',
    port: 8080,
  },
  campaigns: {
    base:
      'https://search-pj-campaigns-index-oyaq7ruf3du2owxiiiuhyqcgcm.eu-west-1.es.amazonaws.com',
    previousCampaignDates: {
      '16': '2019-11-11', // Singles Day
    },
  },
  googleTagManager: 'GTM-KD9S55X',
  translation: 'pl',
  timezone: 'Europe/Warsaw',
  currencyCode: 'PLN',
  url: {
    campaigns: '/akcje-i-kampanie', // TODO: From router when localized
    legacy: {
      brand: '/brand.php',
      category: '/category.php',
      fight: '/fight.php',
      forum: undefined,
      info: '/info.php',
      lists: '/lists.php',
      minhembio: undefined,
      plugin: '/plugins/',
      product: '/product.php',
      raw: '/raw.php',
      store_info: '/shop.php',
      user_login: '/login/login.php',
      mobile_site: 'https://m.prisjakt.poland',
    },
  },
  socialNetworks: {
    instagram: {
      link: 'https://www.instagram.com/kompario.pl',
    },
    facebook: {
      enableLogin: true,
      link: 'https://www.facebook.com/Kompario',
      clientID: '1581143958604712',
      clientSecret: 'ebbe4aeb8faa0f5c21e79a6b372f739a',
      callbackURL: `/_internal/auth/facebook/callback`,
    },
  },
  email: {
    noreply: 'noreply@kompario.pl',
  },
  cdn: {
    base: 'https://pricespy-75b8.kxcdn.com',
    images: 'https://pricespy-75b8.kxcdn.com/',
  },
  routes: {
    themes: {
      path: '/akcje-i-kampanie',
    },
    campaign: {
      path: '/akcje-i-kampanie/:name',
    },
    productCompare: {
      path: '/porownaj/produkty/:productIds?',
    },
    editorialContentListing: {
      path: '/artykuly',
    },
  },
  popularCampaignFilterPaths: [],
  newsletter: {
    apiUrl: 'https://api.getanewsletter.com/v3/',
    apiKey: '',
    list: '',
    gansubFormId: '',
  },
  ads: { active: false, ...adConfig },
  infoPages: [9, 5, 15, 10, 12, 4, 6, 14, 7, 8],
  infoPageMap: {
    userAgreement: 4,
    priceInformation: 5,
    privacyPolicy: 6,
    cookiePolicy: 7,
    contact: 8,
    about: 9,
    registerShop: 10,
    media: 12,
    disclaimer: 14,
    aboutReviews: 15,
    adlink: 'adlink',
    themes: 'themes',
    articles: 'articles',
  },
  privacySettings: {
    responsive: {
      cookieVersion: '4',
      cookieUrl: '/info/przechowywanie-danych--i7',
      privacyUrl: '/info/polityka-prywatnoci--i6',
      privacySettingsUrl: '/privacy-settings',
    },
    desktop: {
      cookieVersion: '4',
      cookieUrl: '/info.php?t=about_cookies',
      privacyUrl: '/info.php?t=about_privacy',
      privacySettingsUrl: '/privacy.php',
    },
    mobile: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
    native: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
  },
  modules: {
    priceInfo: {
      enabled: false,
    },
    categoryInfo: {
      enabled: false,
    },
    userReviewPurchaseDate: {
      enabled: false,
    },
    readableProductInfo: {
      enabled: false,
    },
  },
  showClassicSwitch: false,
  trackingToggles: [
    { name: PrivacySettingToggles.BehaviourTrackingImprovement, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingMarketing, default: false },
    { name: PrivacySettingToggles.BehaviorTrackingSurveys, default: true },
    { name: PrivacySettingToggles.PersonalizedAds, default: true },
    { name: PrivacySettingToggles.Personalization, default: true },
  ],
  cdnCache: {
    enabled: true,
    mode: 'external',
  },
  shopOfTheYear: {},
};

export default market;
